"use client";
import { useEffect, useState } from "react";
//#region packages/@mantine/hooks/src/use-mounted/use-mounted.ts
function useMounted() {
	const [mounted, setMounted] = useState(false);
	useEffect(() => setMounted(true), []);
	return mounted;
}
//#endregion
export { useMounted };

//# sourceMappingURL=use-mounted.mjs.map